import React, { useState } from "react";
import { GrFormSubtract, GrAdd } from "react-icons/gr";
import moment from "moment";
import { VscCalendar } from "react-icons/vsc";
import NewsItem from "./News/NewsItem";
const AccordionItem = ({ heading, content, hasNews, pdate, eventNews }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="Accordion__container">
      <div className="Accordion__container__heading">
        <div>
          <h4>{heading}</h4>
          <div className="Accordion__date__container">
            {" "}
            <VscCalendar size={16} />
            <p className="Accordion__date">{moment(pdate).format("L")}</p>
          </div>
        </div>
        {hasNews ? (
          open ? (
            <GrFormSubtract
              size={22}
              style={{ cursor: "pointer" }}
              onClick={() => setOpen(!open)}
            />
          ) : (
            <GrAdd
              size={22}
              style={{ cursor: "pointer" }}
              onClick={() => setOpen(!open)}
            />
          )
        ) : (
          <></>
        )}
      </div>
      {open ? (
        eventNews &&
        eventNews.map((d, index) => (
          <NewsItem
            key={index}
            imgUrl={d.image_url}
            desc={d.text}
            src={d.source_name}
            pdate={d.date}
            title={d.title}
            url={d.news_url}
            sentiment={d.sentiment}
            show={true}
          />
        ))
      ) : (
        <></>
      )}
    </div>
  );
};

export default AccordionItem;
